import { useTranslation } from '../i18n/LanguageContext';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <p>&copy; {new Date().getFullYear()} {t.copyright} · <a href="/privacy">Privacy Policy</a> · <a href="/terms">Terms of Service</a></p>
    </footer>
  );
}
